"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("../../styles");

var styles = {
  root: {
    position: 'relative',
    fontSize: '12px',
    height: '35px',
    borderRadius: '3px',
    padding: '0 15px',
    cursor: 'pointer',
    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 2px 4px',
    textDecoration: 'none',
    outline: 'none',
    border: 'none',
    transition: 'opacity 500ms ease 0s, background-color 300ms ease 0s',
    color: function color(_ref) {
      var type = _ref.type;
      return type === 'cancel' ? _styles.colors.black : _styles.colors.white;
    },
    background: function background(_ref2) {
      var type = _ref2.type;
      if (type === 'cancel') return _styles.colors.stone;
      if (type === 'warning') return _styles.colors.red;
      return _styles.colors.blue;
    },
    '&:hover': {
      background: function background(_ref3) {
        var type = _ref3.type;
        if (type === 'cancel') return _styles.colors.gray;
        if (type === 'warning') return _styles.colors.redDark;
        return _styles.colors.ceruleanBlue;
      }
    },
    '&:active': {
      boxShadow: 'inset 0 1px 3px 0 rgba(0,0,0,0.5), 0 1px 2px 0 rgba(0,0,0,0.5)',
      background: function background(_ref4) {
        var type = _ref4.type;
        if (type === 'cancel') return _styles.colors.ash;
        if (type === 'warning') return _styles.colors.redDark;
        return _styles.colors.ceruleanBlue;
      }
    }
  },
  disabled: {
    opacity: 0.5,
    pointerEvents: 'none'
  },
  loaderContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  childrenContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    visibility: function visibility(_ref5) {
      var loading = _ref5.loading;
      return loading ? 'hidden' : 'visible';
    }
  }
};
var _default = styles;
exports["default"] = _default;